import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.UGCCountPerTagView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'ugc'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/ugc_count_per_tag"]
  legendsTemplate: JST["backbone/templates/monitoring/reports/executive/hierarchy_legends"]

  initialize: (@options = {}) ->
    @colors = { Benchmark: 'rgba(112, 190, 68, 1)' }
    @colors[@options.settings.accountLabel.codes[0]] = @options.settings.accountLabel.color
    $.each @options.settings.competitorsLabels, (index, label) =>
      @colors[label.codes[0]] = label.color
    @labels = [@options.settings.accountLabel.codes[0]].concat (label.codes[0] for label in @options.settings.competitorsLabels)

  render: ->
    @$el.html(@template(brands: @_colorsByBrands(), labels: @labels, options: @getTemplateOptions()))
    @bindChartsReady(1)
    @addHistogram()
    return this

  labelFilter: ->
    if @getSpecificSettings().ignore_competition
      [].concat @options.settings.accountLabel.codes
    else
      super

  addHistogram: ->
    query = @labelsQuery(@labelFilter(), @labelsStructure())
    query.offset = '-3h'
    @_addHistogram(_.extend({}, query, @getExtraQuery(), must_be_public_comments: true), '#ugc-histogram', { drillDownFunction: (clickEvent) =>
      from = new Date(clickEvent.point.x)
      to = new Date(clickEvent.point.x + clickEvent.point.series.pointInterval)
      {
        date_from: @_formatDate(from)
        date_from_ISO: from.toISOString()
        date_to: @_formatDate(to)
        date_to_ISO: to.toISOString()
        labels: [clickEvent.point.series.name]
      }
    })
